import { render } from "./ServiceDistribution.vue?vue&type=template&id=6c650ec6&ts=true"
import script from "./ServiceDistribution.vue?vue&type=script&lang=ts"
export * from "./ServiceDistribution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__